export class BikePart {
    public BikePartId: number;
    public BikeId: number;
    public Serial: string;
    public Name: string;
    public Date: Date;
    public Age: number;
    public Note: string;
}